import Certificate1 from "../img/Sabrina-Carpenter-Mans-Best-Friend.webp";
import Certificate2 from "../img/images (2).webp";
import Certificate3 from "../img/images (3).webp";
import Certificate4 from "../img/images (5).webp";
import Certificate5 from "../img/images (4).webp";
import Certificate6 from "../img/be835b49-b338-40eb-8b17-ee15ddf1112c.jpeg";
import Certificate7 from "../img/5b9e127c-8b42-484d-ab17-7afc389e88d4 (1).webp";
import Certificate8 from "../img/419d0ea358d11ee2509dc30c5544b639.webp";

const certificateImages = [
  Certificate1,
  Certificate2,
  Certificate3,
  Certificate4,
Certificate5,
Certificate6,
Certificate7,
Certificate8,
];

export default certificateImages;
